// Arrival awareness for video consultations.
//
// Two sources, one shape. The backend brief
// (~/Desktop/Codex-Brief-Video-Consultation-UX-Backend-2026-10-22.md, §3)
// specifies both:
//   * a cheap `GET /api/v1/practices/<p>/pms/appointments/<id>/virtual-join/`
//     returning the consultation metadata (including `patient_present` /
//     `host_present`) without minting a Daily token, and
//   * a realtime message `virtual_consultation.presence` on the practice
//     channel LiveNotificationHandler already consumes, carrying
//     `appointment_id` plus the same flags.
// NEITHER IS LIVE YET: the GET answers 405 today and no publisher sends the
// message. Everything here therefore treats absence as "not known" and never
// as "nobody is waiting".
//
// LiveNotificationHandler re-broadcasts the realtime payload as a window
// CustomEvent (exactly as it does for `voice.call`) so any mounted page can
// react without opening a second socket.

// PieSocket channel event name, and the `type` a payload riding
// `new-notification` carries.
export const PRESENCE_MESSAGE_TYPE = 'virtual_consultation.presence';
// window CustomEvent name.
export const PRESENCE_WINDOW_EVENT = 'virtual-consultation-presence';

// Accepts the raw socket frame (string or object, optionally wrapped as
// `{ type, data: {...} }`) and returns the presence payload, or null when the
// frame is not a presence message. Mirrors parseVoiceCallPayload.
export const parsePresencePayload = (data) => {
    if (!data) return null;
    let payload = data;
    if (typeof data === 'string') {
        try { payload = JSON.parse(data); } catch { return null; }
    }
    if (!payload || typeof payload !== 'object') return null;
    if (payload.data && typeof payload.data === 'object' && payload.data.appointment_id && !payload.appointment_id) {
        payload = { ...payload, ...payload.data };
    }
    const isPresence = payload.type === PRESENCE_MESSAGE_TYPE || payload.event === PRESENCE_MESSAGE_TYPE;
    return isPresence && payload.appointment_id != null ? payload : null;
};

// The diary and upcoming-appointment serializers will nest the flags under
// `video_presence` (brief §3); the appointment detail payload carries them
// flat. Read both, and only ever assert presence on an explicit `true`.
export const rowPatientPresent = (row) =>
    row?.video_presence?.patient_present === true || row?.patient_present === true;
